<template>
  <div class="content-padding" style="width:100%">
    <div v-for="(item, index) in histories" :key="index" :class="item && item.user === user ? 'remark-self' : ''">
      <span v-if="item.badge" class="badge-dot"></span>
      <span class="remark-date">
        {{ dateFormat(item.createdAt) }} <span class="remark-time">{{ dateFormat(item.createdAt, 'HH:MM') }}</span> --
        {{ item.user }}
      </span>
      <span style="padding-left: 10px;"> {{ item.content }}</span>
    </div>

    <el-input
      v-if="editVisible"
      v-model="newFeedBack"
      :rows="2"
      :autosize="{ minRows: 2 }"
      type="textarea"
      :placeholder="placeholder"
    />

    <div v-if="editVisible" class="btn-box">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="saveFeedBack">保 存</div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    editVisible: { type: Boolean, default: false },
    histories: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
  },
  data() {
    return {
      newFeedBack: '',
      user: '',
    }
  },
  mounted() {
    this.user = app.user.account
  },
  methods: {
    saveFeedBack() {
      this.$emit('addFeedBack', { user: this.user, content: this.newFeedBack })
    },
    clear() {
      this.newFeedBack = ''
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
  },
}
</script>
<style scoped>
.content-padding {
  padding: 0 8px;
}
.btn-box {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
}
.badge-dot {
  height: 8px;
  width: 8px;
  padding: 0;
  right: 0;
  border-radius: 50%;
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}
</style>
